var merge = require('lodash/merge')

const mutations = {
  SET_SEL_PERSON (state, person) {
    state.person = person
  },
  UPDATE_SEL_PERSON(state, person) {
    const mergedData = merge(state.person,person)
    state.person = mergedData
  }
 
}
export default mutations
